// components/common/labelWithIcon/LabelWithIcon.tsx
import { Bell } from "lucide-react"

import clsx from "clsx"

export type NotificationBadgeType = "success" | "danger";

export interface NotificationConfig {
  type: NotificationBadgeType;
  count: number;
  pulse?: boolean;
}

const NotificationBadge = ({ notification }: { notification: NotificationConfig }) => {
  const { type, count, pulse = false } = notification

  const typeStyles = {
    success: {
      container: "bg-green-600 text-white",
      icon: "text-white",
    },
    danger: {
      container: "bg-red-500 text-white border-red-200",
      icon: "text-withe",
    },
    "success-pulse": {
      container: "bg-green-100 text-green-600 border-green-200",
      icon: "text-green-600",
    },
    "danger-pulse": {
      container: "bg-red-100 text-red-600 border-red-200",
      icon: "text-red-600",
    },
  }

  const styles = typeStyles[`${type}${pulse ? "-pulse" : ""}`]

  return (
    <div
      className={clsx(
        "flex items-center gap-1.5 px-2 py-1 rounded-full border text-xs font-semibold",
        styles.container,
        pulse && "animate-pulse",
      )}>
      <Bell className={clsx("h-3.5 w-3.5", styles.icon)} />
      <span>{count !== undefined && count > 99 ? "99+" : count}</span>
    </div>
  )
}


export default NotificationBadge